import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { QuestionCard } from './QuestionCard';
import { SectionBlock, PointsACreuser, CriteresBlock, QuestionsSection } from './InterviewKitSections';
import { renderValue, getLabel } from './interviewKitUtils';


const InterviewKitContent = ({ interviewKit }) => {
    if (!interviewKit) return null;

    if (Array.isArray(interviewKit) && interviewKit.every(i => typeof i === 'string')) {
        return (
            <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                {interviewKit.map((q, idx) => (
                    <Card key={`kitstr-${idx}`} sx={{ p: 2.5, borderRadius: 2, border: '1px solid #e2e8f0', boxShadow: 'none', display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                        <Box sx={{ width: 28, height: 28, borderRadius: '50%', backgroundColor: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <Typography sx={{ color: '#3b82f6', fontWeight: 800, fontSize: '0.75rem' }}>{idx + 1}</Typography>
                        </Box>
                        <Typography variant="body2" sx={{ color: '#334155', fontWeight: 500, lineHeight: 1.6, pt: 0.3 }}>{q}</Typography>
                    </Card>
                ))}
            </Box>
        );
    }


    if (Array.isArray(interviewKit) && interviewKit.every(i => typeof i === 'object')) {
        return (
            <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                {interviewKit.map((item, idx) => <QuestionCard key={`kitobj-${idx}`} item={item} idx={idx} />)}
            </Box>
        );
    }


    if (typeof interviewKit === 'string') {
        return (
            <Box sx={{ mt: 3, p: 3, backgroundColor: '#f8fafc', borderRadius: 2, whiteSpace: 'pre-wrap', color: '#334155', lineHeight: 1.8, fontSize: '0.9rem' }}>
                {interviewKit}
            </Box>
        );
    }

    if (typeof interviewKit === 'object' && interviewKit !== null) {
        return (
            <Box sx={{ mt: 3 }}>
                {Object.entries(interviewKit).map(([key, val], sectionIdx) => {
                    if ((key === 'points_a_creuser' || key === 'points_to_dig') && Array.isArray(val))
                        return <Box key={`sec-${sectionIdx}`}><PointsACreuser points={val} /></Box>;

                    if (key === 'questions' && Array.isArray(val))
                        return <Box key={`sec-${sectionIdx}`}><QuestionsSection questions={val} /></Box>;

                    if (['criteres_evaluation', 'evaluation_criteria', 'criteres'].includes(key) && Array.isArray(val)) {
                        const isStructured = val.length > 0 && typeof val[0] === 'object'
                            && (val[0].critere || val[0].criteria || val[0].poids || val[0].echelle);
                        return isStructured
                            ? <Box key={`sec-${sectionIdx}`}><CriteresBlock criteres={val} /></Box>
                            : <Box key={`sec-${sectionIdx}`}><SectionBlock sectionKey={key} sectionValue={val} sectionIdx={sectionIdx} /></Box>;
                    }

                    if (Array.isArray(val))
                        return <SectionBlock key={`sec-${sectionIdx}`} sectionKey={key} sectionValue={val} sectionIdx={sectionIdx} />;

                    return (
                        <Box key={`sec-${sectionIdx}`} sx={{ mb: 2, p: 2, backgroundColor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                {getLabel(key)}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#334155' }}>{renderValue(val)}</Typography>
                        </Box>
                    );
                })}
            </Box>
        );
    }

    return null;
};

export default InterviewKitContent;
